/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable import/no-extraneous-dependencies,react/no-danger */
import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import TEXT_STYLE_MAP from '../../../constants/textStyleMap';
import { parseHtml, scrollQuestionIntoView } from '../../../utils';
import { getCssValue, getTooltipProps } from '../../../cruxComponents/utils';

const H1 = styled.h1`
  color: ${({ color }) => color};
  font-size: 30px;
`;

const H2 = styled.h2`
  color: ${({ color }) => color};
  font: ${({ font }) => font};
  margin-bottom: 20px;
  margin-top: ${({ headingsVerticalSpace }) => headingsVerticalSpace};
  & > span,
  & > span > div {
    font: ${({ font }) => font};
  }
  // @media (max-width: 375px) {
  //   font-size: 24px !important;
  // }
`;

const P = styled.p`
  font: ${({ font }) => font};
  color: ${({ color }) => color};
  @media (max-width: 768px) {
    p {
      ${({ pageId }) =>
        (pageId === 'completed' || pageId === 'timeout') && 'font-size:15px !important;'};
    }
  }
  @media (max-width: 300px) {
    p {
      ${({ pageId }) =>
        (pageId === 'completed' || pageId === 'timeout') &&
        'font-size:12px !important;margin-bottom:30px;'};
    }
  }
`;

const R = styled.h3`
  font: ${({ font }) => font};
  color: ${({ color }) => color};
  @media (max-width: 768px) {
    p {
      ${({ pageId }) =>
        (pageId === 'completed' || pageId === 'timeout') && 'font-size:15px !important;'};
    }
  }
  @media (max-width: 300px) {
    p {
      ${({ pageId }) =>
        (pageId === 'completed' || pageId === 'timeout') &&
        'font-size:12px !important;margin-bottom:30px;'};
    }
  }
`;

const H3 = styled.h3`
  color: ${({ color }) => color};
  font-size: 18px;
  margin-bottom: 60px;
`;

const Error = styled.h3`
  color: #ab1b27;
  font-size: 18px;
`;

const Label = styled.div`
  ${({ isAsterisk }) =>
    isAsterisk
      ? `
		&:before{
			content: '*';
			margin: 5px 5px 0 0;
		}
	`
      : ''};
  color: ${({ color }) => color};
  font-size: 18px;
  line-height: 21px;
  margin-bottom: 15px;
  ${({ hasTooltip }) => hasTooltip && 'text-align: justify'};
  font-size: ${({ fontSize }) => fontSize};
  font-weight: ${({ labelText }) => labelText.fontWeight};
  font-family: ${({ labelText }) => labelText.fontFamily};
  font: ${({ font }) => font};
  font: ${({ baseFont }) => baseFont};
`;

function TextElement(props) {
  const {
    text,
    styleType,
    handlePopup,
    elementTheme,
    theme,
    baseFont,
    pFont,
    id,
    isAsterisk,
    questionObj,
    ariaHidden,
    role = '',
    screenViewport,
  } = props;
  const { headingColor, labelColor } = get(theme, 'config.theme.global.text');
  const {
    hint_title: tooltipTitle,
    hint_text: tooltipBody,
    hint_html: tooltipHTML,
    tooltip,
  } = questionObj || {};
  const { hasTooltip } = getTooltipProps(tooltipTitle, tooltipBody, tooltipHTML || tooltip);
  const {
    pageId,
    config: {
      theme: { pageOverrides },
    },
  } = theme;
  const labelText = get(pageOverrides[pageId], 'themeConfiguration.labelText', elementTheme || {});
  const headingsVerticalSpace = get(
    pageOverrides[pageId],
    'headingsVerticalSpace',
    elementTheme || {},
  );
  // CSS Variables
  const _font = getCssValue(theme, 'font', 'textElement-labelText');
  const h2Font = getCssValue(theme, 'font', 'textElement-h2');
  const headingPFont = getCssValue(theme, 'font', 'textElement-heading');

  const handleOnFocus = (e) => {
    const element = e.target;
    scrollQuestionIntoView({
      element,
      theme,
      role,
      screenViewport,
    });
  };

  if (!text) {
    return null;
  }
  switch (TEXT_STYLE_MAP[styleType]) {
    case 'H1':
      return (
        <H1 id={ id } color={ headingColor }>
          <span>{parseHtml(text, handlePopup)}</span>
        </H1>
      );
    case 'H2':
      return (
        <H2
          id={ id }
          color={ headingColor }
          font={ h2Font }
          headingsVerticalSpace={ !role && headingsVerticalSpace }
        >
          <div>{parseHtml(text, handlePopup)}</div>
        </H2>
      );
    case 'H3':
      return (
        <H3 id={ id } color={ headingColor }>
          <span>{parseHtml(text, handlePopup)}</span>
        </H3>
      );
    case 'LABEL':
      return (
        <Label
          id={ id }
          color={ labelColor }
          labelText={ labelText }
          font={ _font }
          baseFont={ baseFont }
          isAsterisk={ isAsterisk }
          hasTooltip={ hasTooltip }
          onFocus={ handleOnFocus }
        >
          <span aria-hidden={ ariaHidden }>{parseHtml(text, handlePopup, isAsterisk)}</span>
        </Label>
      );
    case 'ERROR':
      return (
        <Error id={ id }>
          <span>{parseHtml(text, handlePopup)}</span>
        </Error>
      );
    case 'NORMAL':
      return (
        <P font={ pFont }>
          <span>{parseHtml(text, handlePopup)}</span>
        </P>
      );
    case 'HEADING':
      return (
        <P font={ headingPFont }>
          <span>{parseHtml(text, handlePopup)}</span>
        </P>
      );
    case 'REVIEW_HEADING':
      return (
        <R font={ headingPFont }>
          <span>{parseHtml(text, handlePopup)}</span>
        </R>
      );
    default:
      return (
        <P id={ id } pageId={ pageId } color={ labelColor }>
          <span>{parseHtml(text, handlePopup)}</span>
        </P>
      );
  }
}

TextElement.defaultProps = {
  id: null,
};

TextElement.propTypes = {
  styleType: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  id: PropTypes.string,
};

export default withTheme(TextElement);
